import React from "react";
import { Link } from "react-router-dom";
import { Crosshair } from "lucide-react";
import { TargetLogo } from "../../components/Logo";

export function About() {
  return (
    <div className="mx-auto max-w-[900px] px-5 py-7">
      <div className="text-center">
        <div className="flex justify-center"><TargetLogo size={56} /></div>
        <h1 className="mt-5 text-2xl font-extrabold tracking-tight text-ink">About the Portal</h1>
        <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-muted">
          The GRS Shoot Results Portal is the official results and statistics platform for shooting competitions
          running the GRS BLADE system. It imports shot data recorded by the SMT electronic targets and server, then
          combines it with competitor and competition information to produce results tables, rankings and long-term
          statistics.
        </p>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {[
          ["Permanent History", "Every competitor is identified by an Association-issued SID, so every score contributes to a single permanent history."],
          ["Independent Platform", "The target controller stays lightweight — all reporting and statistics happen here on the platform."],
          ["Built to Grow", "Rankings, aggregates and analytics grow over many years without changes to range hardware."],
        ].map(([t, d]) => (
          <div key={t} className="card p-6">
            <Crosshair size={22} className="text-primary" />
            <h3 className="mt-3 text-[15px] font-bold text-ink">{t}</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-muted">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-20 text-center">
      <TargetLogo size={72} />
      <h1 className="mt-6 text-7xl font-extrabold tracking-tight text-ink">404</h1>
      <p className="mt-3 text-lg font-semibold text-ink">Shot missed — page not found.</p>
      <p className="mt-1 text-[15px] text-muted">The page you're looking for doesn't exist or has been moved.</p>
      <Link
        to="/"
        className="mt-8 inline-flex h-11 items-center rounded-lg bg-primary px-6 text-sm font-bold text-white transition-colors hover:bg-primary-hover"
      >
        Back to Home
      </Link>
    </div>
  );
}
